import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";
// import { fetchWrapper } from "../_helpers/fetch-wrapper";

// create slice

const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    user: JSON.parse(localStorage.getItem("user")),
    isLoggedIn: JSON.parse(localStorage?.getItem("isLoggedIn")),
    forgotPasswordResponse: {},
    resetPasswordResponse: {},
    changePasswordResponse: {},
    logoutResponse: {},
    verifyTwoFactorResponse: {},
    error: null,
  };
}

function createReducers() {
  return {
    updateUser,
    clearForgotPasswordResponse,
  };

  function updateUser(state, action) {
    state.user = action.payload;
  }

  function clearForgotPasswordResponse(state) {
    state.forgotPasswordResponse = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/users`;

  return {
    login: login(),
    logout: logout(),
    forgotPassword: forgotPassword(),
    resetPassword: resetPassword(),
    changePassword: changePassword(),
    verifyTwoFactor: verifyTwoFactor(),
  };

  function login() {
    return createAsyncThunk(
      `${name}/login`,
      async (loginForm) =>
        await fetchWrapper.post(`${baseUrl}/login`, loginForm),
    );
  }

  function logout() {
    return createAsyncThunk(
      `${name}/logout`,
      async () => await fetchWrapper.get(`${baseUrl}/logout`),
    );
  }

  function forgotPassword() {
    return createAsyncThunk(
      `${name}/forgotpassword`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/forgotpassword`, data),
    );
  }

  function changePassword() {
    return createAsyncThunk(
      `${name}/changePassword`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/changePassword`, data),
    );
  }
  function verifyTwoFactor() {
    return createAsyncThunk(
      `${name}/verifyTwoFactor`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/verifyTwoFactor`, data),
    );
  }

  // function resetPassword(){
  //   return createAsyncThunk(
  //     `${name}/resetpassword`,
  //     async (data) =>
  //       {

  //         return await fetchWrapper.post(`${baseUrl}/resetpassword/aee319cb4190bc9991d0765c5bfb433b87ecae04`, data)
  //       }
  //   );
  // }

  function resetPassword() {
    return createAsyncThunk(`${name}/resetpassword`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/resetpassword/${data?.token}`,
        data,
      );
    });
  }
}

function createExtraReducers(builder) {
  builder
    // Login
    .addCase(extraActions.login.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.login.fulfilled, (state, action) => {
      debugger;
      const user = action.payload;
      const isAdminPanel = action?.meta?.arg?.isAdminPanel;
      if (isAdminPanel) {
        sessionStorage.setItem("isLoggedIn", true);
        sessionStorage.setItem("userRoleID", user?.data?.user?.role);
        sessionStorage.setItem(
          "loggedUserName",
          user?.data?.user?.firstName + " " + user?.data?.user?.lastName,
        );
        // sessionStorage.setItem(
        //   "committee_Id",
        //   JSON.stringify(user?.data?.user?.committees)
        // );

        sessionStorage.setItem(
          "committee_Id",
          JSON.stringify([
            ...user?.data?.user?.committees,
            ...user?.data?.user?.committeesAdmin,
          ]),
        );
      }

      state.user = user;
      state.isLoggedIn = true;
    })
    .addCase(extraActions.login.rejected, (state, action) => {
      state.error = action.error;
    })

    // Forgot Password
    .addCase(extraActions.forgotPassword.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.forgotPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.forgotPasswordResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.forgotPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to forgot password";
    })

    // Reset Password
    .addCase(extraActions.resetPassword.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.resetPasswordResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.resetPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to Reset Password";
    })

    // Change Password
    .addCase(extraActions.changePassword.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.changePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.changePasswordResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.changePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to Change Password";
    })

    //logout
    .addCase(extraActions.logout.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.logout.fulfilled, (state, action) => {
      state.loading = false;
      state.logoutResponse = action?.payload;
      sessionStorage.removeItem("isLoggedIn");
      sessionStorage.removeItem("userRoleID");
      // localStorage.setItem("committee_Id", user?.data?.user?.committees);
      sessionStorage.removeItem("loggedUserName");
      sessionStorage.removeItem("committee_Id");
      sessionStorage.removeItem("savedState");
      state.error = null;
    })
    .addCase(extraActions.logout.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get committees";
    })

    //verifyTwoFactor
    .addCase(extraActions.verifyTwoFactor.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.verifyTwoFactor.fulfilled, (state, action) => {
      debugger;
      state.loading = false;
      state.verifyTwoFactorResponse = action?.payload;
      const user = action.payload;
      sessionStorage.setItem("isLoggedIn", true);
      sessionStorage.setItem("userRoleID", user?.data?.user?.role);
      sessionStorage.setItem(
        "loggedUserName",
        user?.data?.user?.firstName + " " + user?.data?.user?.lastName,
      );
      sessionStorage.setItem(
        "committee_Id",
        JSON.stringify(action?.payload?.data?.user?.committees),
      );

      state.error = null;
    })
    .addCase(extraActions.verifyTwoFactor.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get committees";
    });
}
